import { connect } from 'react-redux';
import Application from './application';

const mapStateToProps = ({
  canvas: { sharingUrl, name },
  exporting: { showSharing, previewSrc }
}) => ({
  sharingUrl: showSharing ? sharingUrl : null,
  previewSrc,
  name
});

export default connect(mapStateToProps, {})(Application);
